import { generateUniqueDealLineName } from 'components/pages/Planner/hooks/utils/createNewDirectSalesLine';
import { ProductLine } from './reducer.types';

export const getNewProductLineNameAndId = (productLines: ProductLine[]): { lineId: string; name: string } => {
  const existingNames = productLines.map((line) => line.name.toLowerCase());
  const name = generateUniqueDealLineName(existingNames, productLines.length + 1, 'Line');
  const maxLineId = Math.max(...productLines.map((line) => parseInt(line.lineId) || 0));
  const lineId = String(maxLineId + 1);

  return { lineId, name };
};
